exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MemberScreen .Wrap {\n  padding: 0; }\n", ""]);

// exports
